import React from "react";
import ReactDom from "react-dom";
import { Button as Btn } from "react-md";
import { Col, FormGroup, UncontrolledTooltip as Uct } from "reactstrap";
import { notifica } from "../requests/utils";
import Modalform from "../components/Modalform";
import { getAlertas, eliminaAlerta } from "../requests/req_alertas";
import Swal from "sweetalert2";
import {
  AddAlarmSVGIcon,
} from "@react-md/material-icons";
import {TextIconSpacing } from "@react-md/icon";

export default class Alertas extends React.Component {
  constructor(props) {
    super(props);
    this.state = { alertas: null };
    this.elimina = this.elimina.bind(this);
    this.clickAlerta = this.clickAlerta.bind(this);
    this.obtieneDatos = this.obtieneDatos.bind(this);
    this.resultElimina = this.resultElimina.bind(this);
    this.generaAlertas = this.generaAlertas.bind(this);
    this.genAlertas = this.genAlertas.bind(this);
  }

  componentDidMount() {
    getAlertas((a) => this.obtieneDatos(a));
  }
  genAlertas() {
    getAlertas((a) => this.obtieneDatos(a));
  }
  elimina(e) {
    const elm = e.target;
    Swal.fire({
      title: "¿Deseas eliminar la alerta?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.value) {
        var btn = elm.tagName === "I" ? elm.parentElement : elm,
          id = btn.getAttribute("idalerta"),
          bx = document.getElementById("bx_" + id),
          lbl = document.getElementById("lbl_util");

        lbl.innerText = id;
        bx.classList.add("Hide_All");
        eliminaAlerta((e) => this.resultElimina(e));
      }
    });
  }

  resultElimina(res) {
    if (res.code === 0) {
      notifica("info", "Se eliminó exitosamente la alerta.", "Ok");
    } else {
      notifica("danger", res.message, "Error");
    }
  }

  obtieneDatos(res) {
    //let a = document.getElementById("ARC_Alrts");
    // if(a != undefined){
    //   NodeList.prototype.forEach = Array.prototype.forEach
    //   var children = a.childNodes;
    //   children.forEach(function(item){
    //     item.classList.remove('Hide_All')
    //   });
    // }

    if (res.code === 0) {
      if (res.data.length > 0) {
        var dv = document.getElementById("dv_ARc_alrts");
        this.setState({ alertas: res.data });
        ReactDom.render(
          <FormGroup id="ARC_Alrts" className="ARC_Alrts" row>
            {this.generaAlertas(res.data)}
          </FormGroup>,
          dv
        );
      } else {
        notifica("info", "Aún no has generado ninguna alerta.", "Info");
      }
    } else {
      notifica("warning", res.message, "Alerta");
    }
  }

  generaAlertas(datos) {
    return datos.map((a, index) => {
      return (
        <Col
          sm={6}
          md={6}
          lg={6}
          key={index}
          id={"bx_" + a.idAlertaCandidato}
          className="dv_Alrt"
        >
          <div style={{ borderradius: 35 }} className="dv_Alrt_cnt">
            <label className="lbl_bg">
              {'Palabra clave: "' + a.palabraClave + '"'}
            </label>
            <br />
            <label className="lbl_md">{"Categoría: " + a.Categoria}</label>
            <br />
            <label className="lbl_md">{"Estado: " + a.Estado}</label>
            <br />
            <div className="dv_Alrt_cnt_dv">
              <div className="dv_con">
                <label className="lbl_md">
                  {"Sueldo Mínimo Deseado: " + a.salarioMinimo}
                </label>
                <br />
                <label className="lbl_md">
                  {"Estatus: " + (a.idEstatus === 1 ? "Activo" : "Inactivo")}
                </label>
              </div>
              <div className="dv_conR">
                <Btn
                  floating
                  primary
                  iconChildren="delete"
                  className="btn_trns_sml"
                  id={"btnEl" + a.idAlertaCandidato}
                  idalerta={a.idAlertaCandidato}
                  onClick={this.elimina}
                />
                <Uct placement="left" target={"btnEl" + a.idAlertaCandidato}>
                  Eliminar
                </Uct>
                <Btn
                  floating
                  primary
                  iconChildren="create"
                  className="btn_alert_sml"
                  id={"btnEdt" + a.idAlertaCandidato}
                  onClick={(e) => this.clickAlerta(e, a.idAlertaCandidato)}
                />
                <Uct placement="right" target={"btnEdt" + a.idAlertaCandidato}>
                  Editar
                </Uct>
              </div>
            </div>
          </div>
        </Col>
      );
    });
  }

  clickAlerta(e, IdAlerta) {
    document.getElementById("lbl_Modal").innerText = IdAlerta;
    document.getElementById("BtnMdl").click();
  }

  render() {
    return (
      <div className="ARC_Alertas">
        <Btn
          className="btn_alarm"
          iconChildren="MdAlarmAdd"
          onClick={(e) => this.clickAlerta(e, 0)}
        >
          <TextIconSpacing icon={<AddAlarmSVGIcon />}>Nueva Alerta</TextIconSpacing>
        </Btn>
        <Modalform
          modulo={"Alertas"}
          btnsv={"Guardar Alerta"}
          datos={this.state.alertas}
        />
        <div id="dv_ARc_alrts" />
        <button
          id="GeneraDiv"
          className="Hide_All"
          onClick={this.genAlertas}
        ></button>
      </div>
    );
  }
}
